export default () => ({
  user: null,
  token: null,
  headers: null,
  login: {
    isSuccess: false,
    isAlert: false,
    message: '',
    responseData: '',
  },
  companies: [],
  workspace: null,
  company: null,
  isLogged: false,
  isRoleApplication: null,
  registerEmail: ''
})
